import { Location } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { IconComponent } from '@reforgium/icon';
import { LangPipe, LangService, RouteWatcher } from '@reforgium/presentia';

import { urls } from 'constants/urls.constant';

import { Breadcrumb } from 'interfaces/breadcrumb';

import { DictService } from 'use-cases/dict.service';

@Component({
  selector: 'app-breadcrumbs',
  imports: [RouterLink, IconComponent, LangPipe],
  template: `
    <nav class="flex items-center gap-2" aria-label="Хлебные крошки">
      <re-icon name="home-filled" width="12" />
      <re-icon name="chevron" width="16" />

      <a [routerLink]="urls.home">
        <span>Главная</span>
      </a>

      @for (crumb of breadcrumbsWithCategory(); track crumb.title + crumb.url) {
        <re-icon name="chevron" width="16" />

        @if (crumb.url === urls.back) {
          <button class="cursor-pointer" (click)="back($event)">
            <span>{{ crumb.translate === false ? crumb.title : (crumb.title | lang) }}</span>
          </button>
        } @else if (crumb.url === urls._) {
          <button class="cursor-pointer" (click)="refresh($event)">
            <span>{{ crumb.translate === false ? crumb.title : (crumb.title | lang) }}</span>
          </button>
        } @else {
          <a [routerLink]="crumb.url" [queryParams]="crumb.queryParams">
            <span>{{ crumb.translate === false ? crumb.title : (crumb.title | lang) }}</span>
          </a>
        }
      }
    </nav>
  `,
  styles: `
    nav {
      color: var(--text-secondary);
      white-space: nowrap;
      width: fit-content;
    }

    a,
    button {
      font-size: calc(12px * var(--a11y-font-scale, 1));
      line-height: 1.4;
    }
  `,
})
export class BreadcrumbsComponent {
  protected readonly urls = urls;

  private location = inject(Location);
  protected watcher = inject(RouteWatcher);
  private dictService = inject(DictService);
  private langService = inject(LangService);
  protected readonly breadcrumbs = this.watcher.selectData<Breadcrumb[]>('breadcrumbs');
  protected readonly categoryId = this.watcher.selectQuery<string>('categoryId');
  protected readonly breadcrumbsWithCategory = computed(() => {
    this.langService.currentLang();

    const breadcrumbs = this.breadcrumbs() ?? [];
    const categoryId = Number(this.categoryId());

    if (!Number.isInteger(categoryId) || categoryId <= 0) {
      return breadcrumbs;
    }

    const category = this.dictService.categories.items().find((item) => item.id === categoryId);
    const documentsCrumbIndex = breadcrumbs.findIndex((crumb) => crumb.url === urls.documentsList);

    if (!category) {
      return breadcrumbs;
    }

    const categoryBreadcrumb = {
      title: category.name,
      url: urls.documentsList,
      queryParams: { categoryId: category.id },
      translate: false,
    };

    if (documentsCrumbIndex < 0) {
      return [categoryBreadcrumb, ...breadcrumbs];
    }

    return [
      ...breadcrumbs.slice(0, documentsCrumbIndex),
      categoryBreadcrumb,
      ...breadcrumbs.slice(documentsCrumbIndex),
    ];
  });

  refresh(event: Event) {
    event.preventDefault();
    window.location.reload();
  }

  back(event: Event) {
    event.preventDefault();
    this.location.back();
  }
}
